import { Modal } from "antd";
import dayjsTZ from "../../../../utils/dayjs";
import useOpenOnce from "../../../../hooks/useOpenOnce";
import useAquamanDuty from "../../../../hooks/useAquamanDuty";
import "./AquamanModal.scss";

// The alert only the assigned employee sees, once per duty week: `isMyDuty`
// comes from the backend comparing the caller's employeeId with the week's
// assignee, and the localStorage key is scoped to that week so the next turn
// pops up again.
const AquamanModal = () => {
  const { current, roster, isMyDuty } = useAquamanDuty({ upcoming: 1 });

  const featureName = current?.weekStart
    ? `aquaman-${current.weekStart}`
    : "aquaman-none";
  const [open, setOpen] = useOpenOnce(featureName, "aquamanDuty", 2000, true);

  if (!isMyDuty || !current?.weekStart) return null;

  const range = `${dayjsTZ(current.weekStart).format("DD/MM")} - ${dayjsTZ(
    current.weekEnd
  ).format("DD/MM/YYYY")}`;

  return (
    <Modal
      className="aquamanModal"
      open={open}
      onCancel={() => setOpen(false)}
      onOk={() => setOpen(false)}
      okText="E kuptova"
      cancelButtonProps={{ style: { display: "none" } }}
      centered
      width={460}
      title={`${roster?.dutyLabel || "Aquaman"} i javës`}
    >
      <div className="aquamanModalBody">
        <span className="aquamanModalIcon" role="img" aria-label="water">
          💧
        </span>
        <h3>Këtë javë ({range}) ju jeni Aquaman!</h3>
        <p>
          {current.status === "covered"
            ? "Zëvendësoni një koleg që është me leje — java e tij do t'i kthehet më vonë."
            : "Kujdesi për ndërrimin e ujit në zyrë është me radhë, dhe kjo javë është e juaja."}
          {roster?.teamLabel ? ` Dega: ${roster.teamLabel}.` : ""}
        </p>
      </div>
    </Modal>
  );
};

export default AquamanModal;
